import * as React from "react"
import { type LucideIcon } from "lucide-react"
import { useLocation, useNavigate } from "react-router-dom"
import { handleNavigationWithPaywall, isEssentialEightRoute } from "@/utils/paywall-navigation-utils"
import { TOUR_STEP_IDS } from "@/lib/tour-constants"

import { isMenuItemActive } from "@/utils/sidebar-utils"

import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"

function Home({
  items,
  ...props
}: {
  items: {
    title: string
    url: string
    icon?: LucideIcon | ((props: any) => React.ReactElement)
    routeName?: string
  }[]
} & React.ComponentPropsWithoutRef<typeof SidebarGroup>) {
  const location = useLocation();
  const navigate = useNavigate();
  const currentPath = location.pathname.substring(1); // Get current path without leading slash
  
  return (
    <SidebarGroup {...props}>
      <SidebarGroupContent>
        <SidebarMenu>
          {items.map((item, index) => (
            <SidebarMenuItem key={item.title}>
              <SidebarMenuButton 
                asChild 
                size="sm" 
                isActive={isMenuItemActive(item.url, currentPath)}
                id={index === 0 ? TOUR_STEP_IDS.HOME_BUTTON : undefined}
              >
                <button type="button" className="w-full flex items-center gap-2 text-left" onClick={(e) => {
                  handleNavigationWithPaywall(item.url, navigate, e, item?.routeName);
                }}
                onAuxClick={(e) => {
                  // Middle click
                  handleNavigationWithPaywall(item.url, navigate, e, item?.routeName);
                }}
                onContextMenu={(e) => {
                  // Right click - prevent context menu and open in new tab
                  e.preventDefault();
                  handleNavigationWithPaywall(item.url, navigate, e, item?.routeName);
                }}
                data-sentry-unmask>
                  {item.icon && <item.icon data-sentry-unmask />}
                  <span data-sentry-unmask>{item.title}</span>
                </button>
              </SidebarMenuButton>
            </SidebarMenuItem>
          ))}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  )
}

export { Home }